<template>

    <a class="btn_tab" :class="{active: activeTab}" @click="handleClick">
        <slot />
    </a>

</template>

<script>
export default {
    name: 'BtnTab',
    props: ['activeTab', 'btnId'],
    computed: {
        isActive(){
            return (this.activeTab === this.btnId) ? true : false
        }
    },
    methods: {
        handleClick(){
            this.$emit('btnTab:Clicked', this.btnId)
        }
    }
}


</script>

<style lang="scss">
.btn_tab{
    user-select: none;
    text-align: center;
    display: block;
    border-bottom: 5px solid transparent;
    color: $grey-light;
    font-weight: 600;
    line-height: 60px;
    text-transform: uppercase;
    margin:0 12px;
    &:hover{
        border-bottom: 5px solid $grey-lighter;
    }
    &.has-error{
        color: $danger;
        border-color: $danger;
    }
    &.active{
        border-bottom: 5px solid $info;
    }
}
</style>